export default "__VITE_ASSET__08a7ef63__"